/** Random — jitter every point of the mark, distorting it. */
import type { AffectModule } from '../../core/module-api';
import { cfgNum } from '../../core/module-api';
import { cloneShape } from '../../core/scene';
import { transformPath } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12h3l2-5 3 10 2-7 2 4h6"/></svg>';

export function createRandom(): AffectModule {
  return {
    manifest: {
      id: 'random',
      kind: 'affect',
      name: 'Random',
      apiVersion: 1,
      description: 'Distort the mark by nudging every point at random.',
      icon: ICON,
      capabilities: ['random'],
      params: [{ kind: 'slider', key: 'amount', label: 'Amount', min: 0, max: 40, step: 1, default: 10 }],
    },

    affect(shapes, ctx) {
      const amt = cfgNum(ctx.config, 'amount', 10);
      if (amt <= 0) return shapes.slice();
      return shapes.map((s) => {
        const c = cloneShape(s);
        c.path = transformPath(s.path, (p) => ({
          x: p.x + (ctx.rng.next() - 0.5) * 2 * amt,
          y: p.y + (ctx.rng.next() - 0.5) * 2 * amt,
        }));
        return c;
      });
    },
  };
}
